import { render, staticRenderFns } from "./Tab.vue?vue&type=template&id=6c686f40"
import script from "./Tab.vue?vue&type=script&lang=ts"
export * from "./Tab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c686f40')) {
      api.createRecord('6c686f40', component.options)
    } else {
      api.reload('6c686f40', component.options)
    }
    module.hot.accept("./Tab.vue?vue&type=template&id=6c686f40", function () {
      api.rerender('6c686f40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sale-layout-editor/Tab.vue"
export default component.exports